import apiWrapper from '../../services/apiWrapper';

export const deleteChurches = async (churchIds) => {
  try {
    const response = await apiWrapper('delete', '/admin/deletechurches', { churchIds });
    
    if (!response.success) {
      throw new Error('Failed to delete churches');
    }

    return response;
  } catch (error) {
    console.error('Error deleting churches:', error);
    throw error;
  }
};